import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

interface MovieCardProps {
  movie: Movie;
  index?: number;
}

export default function MovieCard({ movie, index = 0 }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col animate-fade-in-up"
      style={{ animationDelay: `${Math.min(index, 8) * 45}ms` }}
    >
      <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-800 border border-background-800 group-hover:border-primary-600 transition-colors">
        <img
          src={movie.cover}
          alt={`${movie.title} 海报`}
          title={`${movie.title} 剧情介绍`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-transparent to-transparent" />

        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md text-[11px] font-medium bg-background-950/80 text-foreground-100 backdrop-blur-sm">
          {movie.type}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md text-[11px] font-bold bg-accent-500 text-foreground-950">
          {movie.rating}
        </span>

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <span className="inline-flex items-center gap-1 text-[11px] text-accent-300">
            <i className="ri-fire-line"></i>
            {(movie.heat / 1000).toFixed(1)}k 热度
          </span>
        </div>
      </div>

      <h3 className="mt-2.5 text-sm md:text-base font-medium text-foreground-100 truncate group-hover:text-accent-400 transition-colors">
        {movie.title}
      </h3>
      <p className="mt-1 text-xs text-foreground-500 truncate">
        {movie.genres.join(" · ")} · {movie.region}
      </p>
      <p className="mt-0.5 text-xs text-foreground-600">
        更新于 {movie.updateTime}
      </p>
    </Link>
  );
}